import CasesHigh from "assets/CasesHigh";
import CasesMedium from "assets/CasesMedium";
import CasesLow from "assets/CasesLow";
import CasesInformational from "assets/CasesInformational";

interface Urgency {
  icon: () => JSX.Element;
  description: string;
  count: number;
  circleColor: string;
}

interface Activity {
  description: string;
  count: number;
  circleColor: string;
  percentage: number;
}

interface Result {
  urgencyValues: Urgency[];
  activityValues: Activity[];
}

export function getAnalystDashCasesGridBoxData(t, theme, data: any[], totalCount: number): Result {
  const urgency: Record<string, Urgency> = {
    'fatal': {
      icon: CasesHigh,
      description: t("SEVERITY.FATAL"),
      count: 0,
      circleColor: theme.colors.fatal_criticality
    },
    'critical': {
      icon: CasesHigh,
      description:  t("SEVERITY.CRITICAL"),
      count: 0,
      circleColor: theme.colors.critical_criticality
    },
    'high': {
      icon: CasesHigh,
      description: t("SEVERITY.HIGH"),
      count: 0,
      circleColor: theme.colors.high_criticality
    },
    'medium': {
      icon: CasesMedium,
      description: t("SEVERITY.MEDIUM"),
      count: 0,
      circleColor: theme.colors.medium_criticality
    },
    'low': {
      icon: CasesLow,
      description: t("SEVERITY.LOW"),
      count: 0,
      circleColor: theme.colors.low_criticality
    },
    'informative': {
      icon: CasesInformational,
      description: t("SEVERITY.INFORMATIVE"),
      count: 0,
      circleColor: theme.colors.informative_criticality
    },
    'unclassified': {
      icon: CasesInformational,
      description: t("SEVERITY.OTHER"),
      count: 0,
      circleColor: theme.colors.unclassified_criticality
    },
  }

  const activity: Record<string, Activity> = {
    'open': {
      description: t("STATUS.OPEN"),
      count: 0,
      circleColor: theme.colors.open_incident,
      percentage: 0
    },
    'inprogress': {
      description: t("STATUS.IN_PROGRESS"),
      count: 0,
      circleColor: theme.colors.in_progress_incident,
      percentage: 0
    },
    'closed': {
      description: t("STATUS.CLOSED"),
      count: 0,
      circleColor: theme.colors.closed_incident,
      percentage: 0
    },
    'tuningrequested': {
      description: t("STATUS.REQUEST_TUNING"),
      count: 0,
      circleColor: theme.colors.requested_incident,
      percentage: 0
    },
  };
  
  
  data.forEach((item) => {    
    if (item.severity) {
      // Add To Urgency Count
      urgency[item.severity.toLowerCase()]["count"] += 1;
    }
    
    if (item.status) {
      // Add to Activity Count
      activity[item.status.toLowerCase().replaceAll(/\s/g,'')]["count"] += 1;
      activity[item.status.toLowerCase().replaceAll(/\s/g,'')]["percentage"] = (
        parseInt(((activity[item.status.toLowerCase().replaceAll(/\s/g,'')]["count"] / totalCount) * 100).toFixed(2))
      )
    }
  });

  const urgencyValues = Object.keys(urgency).map(function(k){return urgency[k]});
  const activityValues = Object.keys(activity).map(function(k){return activity[k]});

  // Return an object with the desired values
  return {
    urgencyValues,
    activityValues,
  };
}

export function getAnalystDashAlertTrends(events: any) {
  const dailyData = Object();
  if (events.length > 0) {
    for (let i = 0; i < events.length; i++) {
      const createdDate = events[i]?.createdDate;
      const dateObj = new Date(createdDate);

      // Skip if date is invalid
      if (!createdDate || isNaN(dateObj.getTime())) continue;

      const timestamp = Math.round(dateObj.getTime() / (1000 * 3600 * 24)) * (1000 * 3600 * 24);
      const day = new Date(timestamp).toISOString().slice(0, 10);

      if (!dailyData[day]) {
        dailyData[day] = {
          name: day,
          unclassified: {
            color: "FF7800",
            count: 0,
            text: "unclassified"
          },
          critical: {
            color: "FF7800",
            count: 0,
            text: "critical"
          },
          fatal: {
            color: "FF7800",
            count: 0,
            text: "fatal"
          },
          high: {
            color: "FF7800",
            count: 0,
            text: "high"
          },
          medium: {
            color: "fa69a1",
            count: 0,
            text: "medium"
          },
          low: {
            color: "FFEB32",
            count: 0,
            text: "low"
          },
          informative: {
            color: "FFEB32",
            count: 0,
            text: "informative"
          }
        };
      }

      // Defensive: check severity exists and is a known key
      const sev = events[i].severity?.toLowerCase();
      if (sev && dailyData[day][sev]) {
        dailyData[day][sev]["count"] += 1;
      }
    }
    return Object.values(dailyData);
  } else {
    return ([
      {
        name: '',
        unclassified: { color: "", count: 0 },
        critical: { color: "", count: 0 },
        fatal: { color: "", count: 0 },
        high: { color: "", count: 0 },
        medium: { color: "", count: 0 },
        low: { color: "", count: 0 },
        informative: { color: "", count: 0 }
      }
    ])
  }
}